module.exports = __webpack_public_path__ + "media/images/gifts/sensations/sug_sensorial_5-78514bd8e40132a9bad09b38a40b18ca.jpg";